import Vue from 'vue'
import Router from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import police from '@/components/police'
import blockly from '@/components/blockly'
import function1 from '@/components/function'
import camera from '@/components/camera'
import test from '@/components/test'
import shop from '@/components/shop'
import light from '@/components/light'
import demo from '@/components/tuoDemo'
import traffic from '@/components/traffic'
import door from '@/components/door'
import index from '@/components/index'
import robot from '@/components/robot'
import car from '@/components/car'
import curtain from '@/components/curtain'
import necklace from '@/components/necklace'
import login from '@/components/login'
import SlideVerify from 'vue-monoplasty-slide-verify';
import unity from '@/components/unity';
import fan from '@/components/fan';
import functionFan from '@/components/functionFan';
import functionFan2 from '@/components/functionFan3';
import functionLight from '@/components/functionLight';
import voice from '@/components/voiceDemo';

Vue.use(Router).use(ElementUI).use(SlideVerify);

export default new Router({
    mode: 'history', //去掉url中的#
    routes: [{
        path: '/police',
        name: 'police',
        component: police
    },
    {
        path: '/fan',
        name: 'fan',
        component: fan
    },
    {
        path: '/blockly',
        name: 'blockly',
        component: blockly
    },
    {
        path: '/function',
        name: 'function',
        component: function1
    },
    {
        path: '/Ffun',
        name: 'Ffun',
        component: functionFan
    },
    {
        path: '/fans',
        name: 'fans',
        component: functionFan2
    },
    {
        path: '/camera',
        name: 'camera',
        component: camera
    },
    {
        path: '/test',
        name: 'test',
        component: test
    },
    {
        path: '/light',
        name: 'light',
        component: light
    },
    {
        path: '/Flight',
        name: 'Flight',
        component: functionLight
    },
    {
        path: '/shop',
        name: 'shop',
        component: shop
    },
    {
        path: '/demo',
        name: 'demo',
        component: demo
    },
    {
        path: '/door',
        name: 'door',
        component: door
    },
    {
        path: '/',
        name: 'index',
        component: index
    },
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/traffic',
        name: 'traffic',
        component: traffic
    },
    {
        path: '/robot',
        name: 'robot',
        component: robot
    },
    {
        path: '/car',
        name: 'car',
        component: car
    },
    {
        path: '/curtain',
        name: 'curtain',
        component: curtain
    },
    {
        path: '/necklace',
        name: 'necklace',
        component: necklace
    },
    {
        path: '/unity',
        name: 'unity',
        component: unity
    },
    {
        path: '/voice',
        name: 'voice',
        component: voice
    }

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js